export const serializeValues = <T extends {}>(
	values: T,
	keys: Array<string>,
	serialize: (value: any) => any
): T => {
	return Object.fromEntries(
		Object.entries(values).map(([key, value]) =>
			keys.indexOf(key) > -1 ? [key, serialize(value)] : [key, value]
		)
	) as T
}

export const mergeValues = <T extends {}>(a: T, b: T): T => {
	const res = Object.assign({}, a)
	Object.entries(b).forEach(([k, v]) => {
		if (k in a) res[k] = v
	})
	return res
}
